module.exports = __webpack_public_path__ + "img/296.1bc5f7b8.jpg";